import React, { useContext, useState, useEffect } from 'react';
import {
	ICustomerFullInfoContext,
	CustomerFullInfoContext,
} from '../../../../../../customerFullInfoState/customerFullInfoContext';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './BpaTab.module.scss';

export const BpaTab: React.FC = () => {
	const { bpaData } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const [idOfCollapsedBlocks, setIdOfCollapsedBlocks] = useState<string[]>([]);

	const handleToggleIsOpenBpaBlock = (blockId: string) => {
		if (idOfCollapsedBlocks.includes(blockId)) {
			const filteredIds = idOfCollapsedBlocks.filter((idOfCollapsedBlock) => idOfCollapsedBlock !== blockId);
			setIdOfCollapsedBlocks(filteredIds);
		} else {
			setIdOfCollapsedBlocks((state) => [...state, blockId]);
		}
	};

	useEffect(() => {
		if (bpaData?.length) {
			setIdOfCollapsedBlocks(bpaData?.map((bpaSet) => bpaSet.id));
		}
	}, [bpaData]);

	return (
		<div className={style.container} data-test="ReportsTab">
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="bpaSetHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				{bpaData?.map((bpaSet) => (
					<div key={bpaSet.id} className={style.bpaSet}>
						<Button
							className={style.expandButton}
							theme="secondaryPurple"
							onClick={() => handleToggleIsOpenBpaBlock(bpaSet.id)}
							iconPosition="post"
							icon={
								<svg
									className={`${style.expandIcon} ${
										idOfCollapsedBlocks.includes(bpaSet.id) ? style.rotated : ''
									}`}>
									<use xlinkHref={`${breadcrumbs}#rightAngleArrow`} />
								</svg>
							}>
							<Text translationNameSpace="form" translationKey={bpaSet.name} asFragment={true} />
						</Button>
						<div className={`${idOfCollapsedBlocks.includes(bpaSet.id) ? style.collapsed : ''}`}>
							<div className={style.row}>
								<FullInfoField
									containerClassName={style.flex1}
									label="setNameLabel"
									value={bpaSet.name}
								/>
								<div className={style.flex1} />
							</div>
							<div className={style.row}>
								<FullInfoField
									label="recipientAccountNumberLabel"
									value={bpaSet.recipientAccountNumber}
								/>
								<FullInfoField label="recipientNameLabel" value={bpaSet.recipientName} />
							</div>
							<div className={style.row}>
								<FullInfoField label="recipientBankLabel" value={bpaSet.recipientBank} />
								<FullInfoField label="recipientBankCityLabel" value={bpaSet.recipientBankCity} />
							</div>
							<div className={style.row}>
								<FullInfoField label="recipientInnLabel" value={bpaSet.recipientInn} />
								<FullInfoField label="recipientBicLabel" value={bpaSet.recipientBic} />
							</div>
							<div className={style.row}>
								<FullInfoField
									label="recipientCorrespondentAccountLabel"
									value={bpaSet.recipientCorrespondentAccount}
								/>
								<FullInfoField label="paymentDetailsLabel" value={bpaSet.paymentDetails} />
							</div>
							<div className={style.row}>
								<FullInfoField label="cardContractNumberLabel" value={bpaSet.cardContractNumber} />
								<FullInfoField label="sbpContractNumberLabel" value={bpaSet.sbpContractNumber} />
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};
